export default __webpack_public_path__ + "static/media/ellipses.9ab3226b.svg";